import { HorseshoeConfig } from '../../../shared/types/podlet';
import { Vertical, Subvertical } from '../../../shared/types/ast';
import { handleLastMinute } from './lastminute';
import { handleCurrency } from './currency';
import { handleContentMarketingFrontpage } from './content-marketing-frontpage';

export function verticalSpesificUpdate(
    config: HorseshoeConfig,
    vertical: Vertical,
    subvertical?: Subvertical,
) {
    if (vertical === 'travel') {
        if (subvertical === 'lastminute') {
            handleLastMinute(config, 500);
        }
    }
}
export function verticalSpesificInit(config: HorseshoeConfig) {
    const { vertical, subvertical } = config;
    if (vertical === 'travel') {
        if (subvertical === 'currency') {
            handleCurrency(config);
        }
    }
}

export function verticalSpecificContentMarketing(config: HorseshoeConfig) {
    const { vertical, subvertical } = config;
    if (vertical === 'realestate') {
        if (!subvertical) {
            handleContentMarketingFrontpage();
        }
    }
}
